<template>
  <v-container fluid fill-height style="background-color: #E6E6E6;">

<!--     <v-layout row wrap align-center v-if="!authenticated">
      <v-flex xs12 class="text-md-center">
          <p class="title my-4"> Access to E-Commerce Pulse is completely free and immediately accessible for registered users. </p>

      </v-flex>

      <v-flex xs12 class="text-md-center">

         <v-img style="margin: auto;cursor: pointer;" :src="pulsePreviewImageUrl" 
                   width="75%"
                   @click="setLoginSignupForm(true)"

         />

      </v-flex>
          </v-layout> -->

<!--     <v-layout row wrap v-if="!authenticated">
      <v-flex md1 lg2 ></v-flex>
      <v-flex md10 lg8>
        <v-card flat>
          <v-card-text>
            <br/>
          <p class="headline">
            E-Commerce Pulse
          </p>
          <v-layout>
            <v-flex lg12>
            <p>
            The E-Commerce Pulse is a smart tool from Contineo Labs designed to monitor trends across Travel Retail's major ecommerce platforms. This report shows high level indicators across 10 major platforms in Asia Pacific, such as available product categories and number of listed brands & products.
            </p>
            <p>
            Contineo Labs specializes in setting up customized monitoring solutions (including pricing & promotions). Feel free to <a href="#" @click="setViewDialogContactUs(true)">get in touch</a> to discuss how we can best support you on those topics.
            </p>

                <p class="title"> Access to the E-Commerce Pulse is <strong>completely free</strong> and <strong>immediately accessible</strong> for registered users.</p>
            </v-flex>

          </v-layout>
          
          </v-card-text>
          <v-card-actions v-if="!authenticated">
            <subscriptionForm subscriptionType='getDemoAccess' /> &nbsp;&nbsp;&nbsp;&nbsp;for free or 
            &nbsp;&nbsp;&nbsp;&nbsp;
            <v-btn flat  class="primary"
              @click="login()">Login</v-btn> &nbsp;&nbsp;&nbsp;&nbsp; if you already have an account.
          </v-card-actions>
        </v-card>
        </v-flex>
      <v-flex md1 lg2 ></v-flex>
    </v-layout> -->
    <v-layout fill-height align-center>
      <v-flex class="text-md-center">
        <iframe 
          :width="($vuetify.breakpoint.height - 90 - 37)*1.77"
          :height="$vuetify.breakpoint.height - 90"
          src="https://app.powerbi.com/view?r=eyJrIjoiOWUxYjQ3YmQtMjQ1OC00ZjU3LThhYWItZGM5NWMwMDljZWRjIiwidCI6IjhiYmNiZTZiLTFlYTEtNDBjNS1iY2Q5LTQ4MjEyN2I5ZDlhYSIsImMiOjh9&pageName=ReportSection" frameborder="0" allowFullScreen="true">
         </iframe>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import Vue from 'vue'
// import { mapState, mapMutations } from 'vuex'

export default {
  name: 'ECommercePulse',
  data () {
    return {
    }
  },
  components: {
  }
  // computed: {
  //   ...mapState([
  //     'authenticated',
  //     'user'
  //   ])
  // },
  // methods: {
  //   ...mapMutations(['setViewDialogContactUs', 'setLoginSignupForm']),
  //   login () {
  //     Vue.prototype.$auth0.login()
  //   },
  //   goToContactForm () {
  //     this.setViewDialogContactUs(true)
  //   }
  // }
}
</script>
<style>
</style>
